import React, {useState, useEffect, useCallback, useRef} from "react";
import Modal from "react-bootstrap/Modal";
import I18n from 'i18n.js.erb'

const ShipmentDataModal = ({
    dataStructureToSetShipmentData,
    setDataStructureToSetShipmentData,
    couriers,
    onChangeOrderStateHandler,
    handleUpdateSubmissionList,
    dataToUpdate,
    setDataToUpdate,
    enableCustomCourier
  }) => {

  const [ selectedCourier, setSelectedCourier ] = useState('')
  const [ trackingNumber, setTrackingNumber ] = useState('')
  const [ otherCourier, setOtherCourier ] = useState('')
  const [ hideUserConfirmShipmentData, setHideUserConfirmShipmentData ] = useState(true)

  useEffect(() => {
    if (dataStructureToSetShipmentData !== null) {
      const handDelivery = searchHandDelivery();
      if (dataToUpdate?.courier?.meta_name && couriersContains([dataToUpdate.courier.id, dataToUpdate.courier.meta_name]))
        setSelectedCourier(dataToUpdate.courier.id)
      else if (dataToUpdate?.courier?.meta_name && dataToUpdate?.courier?.meta_name.toLowerCase().indexOf('by hand') > -1 && handDelivery)
        setSelectedCourier(handDelivery[0]);
      else if (dataToUpdate?.courier?.meta_name)
        setSelectedCourier('Other ...')
      else
        setSelectedCourier('')

      setTrackingNumber(
        dataToUpdate && dataToUpdate.tracking_number ? dataToUpdate.tracking_number : ''
      )
      setOtherCourier('')
    }
    else {
      setSelectedCourier('');
      setTrackingNumber('');
      setOtherCourier('');
      if (setDataToUpdate)
        setDataToUpdate(null);
    }
  }, [dataStructureToSetShipmentData])


  // Funzione che verifica se l'array che contiene tutti i dati dei corrieri ne contiene uno specifico
  const couriersContains = (courier) => {
    for (const c of couriers) {
      if (c[0] === courier[0] && c[1] === courier[1])
        return true;
    }
    return false
  }


  // Funzione che verifica se l'array che contiene tutti i dati dei corrieri, contiene anche il ritiro a mano
  const searchHandDelivery = () => {
    for (const c of couriers) {
      if (c[1].toLowerCase().indexOf('by hand') > -1)
        return c;
    }
    return null
  }


  // Funzione che si occupa di gestire il click da parte dell'utente sul bottone di conferma dei nuovi dati di
  // spedizione relativi a un ordine già spedito dal venditore al compratore o di una submission list il cui grading
  // è stato completato
  const handleConfirm = (e) =>{
    if (onChangeOrderStateHandler) {
      if (dataToUpdate) {
        onChangeOrderStateHandler(
          e,
          dataStructureToSetShipmentData,
          null,
          dataStructureToSetShipmentData.state,
          dataStructureToSetShipmentData.state,
          selectedCourier !== 'Other ...' ? selectedCourier : null,
          selectedCourier === 'Other ...' ? otherCourier : null, trackingNumber
        );

      } else if (['in_progress', 'sent', 'warning'].includes(dataStructureToSetShipmentData.state)) {
        onChangeOrderStateHandler(
          e,
          dataStructureToSetShipmentData,
          "state",
          dataStructureToSetShipmentData.state,
          dataStructureToSetShipmentData.state === "in_progress" ? "sent" : dataStructureToSetShipmentData.state,
          selectedCourier !== 'Other ...' ? selectedCourier : null,
          selectedCourier === 'Other ...' ? otherCourier : null, trackingNumber
        );
      }
    }

    else if (handleUpdateSubmissionList)
      handleUpdateSubmissionList(dataStructureToSetShipmentData.id,
        {
          courier_id: selectedCourier !== 'Other ...' ? selectedCourier : null,
          new_courier: selectedCourier === 'Other ...' ? otherCourier : null,
          tracking_number: trackingNumber
        })
    setHideUserConfirmShipmentData(true)
  }



  return (
    <React.Fragment>
      <Modal
        size="lg"
        show={dataStructureToSetShipmentData !== null}
        onHide={ () => setDataStructureToSetShipmentData(null) }
        animation={false}
        centered
      >
        <Modal.Header>
          {
            hideUserConfirmShipmentData ?
              <Modal.Title>{I18n.t('js.indexOrdersPage.modalShipmentDataTitle')} </Modal.Title>
              :
              <Modal.Title>{I18n.t('js.indexOrdersPage.modalShipmentDataCourierConfirmTitle')}</Modal.Title>
          }
        </Modal.Header>

        <Modal.Body>
          {
            hideUserConfirmShipmentData ?
              <form className="w-100 container">
                <div className="row">
                  <div className="col-xs-12 col-md-6">
                    <p
                      className="text-weight-500">{I18n.t('js.indexOrdersPage.modalShipmentDataCourier')}<sup>*</sup>
                    </p>
                    <select
                      className="form-control"
                      value={selectedCourier}
                      name="courier"
                      id="courier"
                      onChange={(e) => setSelectedCourier(e.target.value)}
                    >
                      <option value={""}
                              disabled={true}>{I18n.t('js.indexOrdersPage.modalShipmentDataCourierPlaceholder')}</option>
                      {couriers.map((courier) => (
                        <option value={courier[0]} key={courier[0]}>
                          {courier[1]}
                        </option>
                      ))}
                      {
                        enableCustomCourier &&
                          <option value="Other ..." key="Other ...">
                            {I18n.t('js.indexOrdersPage.modalShipmentDataCourierNameOther')}
                          </option>
                      }
                    </select>
                  </div>

                  <div className="col-xs-12 col-md-6 mt-3 mt-md-0">
                    <p className="text-weight-500">{I18n.t('js.indexOrdersPage.modalShipmentDataTrackingNumber')}</p>
                    <input
                      type="text"
                      className="form-control"
                      value={trackingNumber}
                      name="tracking_number"
                      id="tracking_number"
                      placeholder={I18n.t('js.indexOrdersPage.modalShipmentDataTrackingNumberPlaceholder')}
                      onChange={(e) => setTrackingNumber(e.target.value)}
                    />
                  </div>

                  {
                    selectedCourier === 'Other ...' &&
                      <div className="col-xs-12 col-lg-6 mt-3">
                        <p
                          className="text-weight-500">{I18n.t('js.indexOrdersPage.modalShipmentDataSpecifyCourier')}<sup>*</sup>
                        </p>
                        <input
                          type="text"
                          className="form-control"
                          value={otherCourier}
                          name="other_courier"
                          id="other_courier"
                          placeholder={I18n.t('js.indexOrdersPage.modalShipmentDataSpecifyCourierPlaceholder')}
                          onChange={(e) => setOtherCourier(e.target.value)}
                        />
                      </div>
                  }
                </div>
              </form>
              :
              <React.Fragment>
                {I18n.t('js.indexOrdersPage.modalShipmentDataCourierConfirmContent')}
              </React.Fragment>
          }
        </Modal.Body>
        <Modal.Footer>
          {
            hideUserConfirmShipmentData ?
              <React.Fragment>
                <button
                  type="button"
                  className="btn-standard-outline br-20px pr-2 pl-2 w-120px btn-standard-outline-resized"
                  onClick={ () => setDataStructureToSetShipmentData(null) }
                >
                  {I18n.t('js.common.button.cancel').toUpperCase()}
                </button>
                <button
                  type="button"
                  className="btn-standard bg-aig-gradient text-light br-20px pr-2 pl-2 w-120px btn-standard-resized pt-4px-imp h-35px font-size-18px-imp"
                  disabled={!selectedCourier || selectedCourier === "" ||
                  (selectedCourier === 'Other ...' && (!otherCourier || otherCourier === ""))}
                  onClick={(e) =>
                     setHideUserConfirmShipmentData(false)
                  }
                >
                  {I18n.t('js.common.button.confirm').toUpperCase()}
                </button>
              </React.Fragment>
              :
              <React.Fragment>
                <button
                  type="button"
                  className="btn-standard-outline br-20px pr-2 pl-2 w-120px btn-standard-outline-resized"
                  onClick={() => setHideUserConfirmShipmentData(true)}
                >
                  {I18n.t('js.common.button.cancel').toUpperCase()}
                </button>
                <button
                  type="button"
                  className="btn-standard bg-aig-gradient text-light br-20px pr-2 pl-2 w-120px btn-standard-resized pt-4px-imp h-35px font-size-18px-imp"
                  disabled={!selectedCourier || selectedCourier === "" ||
                  (selectedCourier === 'Other ...' && (!otherCourier || otherCourier === ""))}
                  onClick={ (e) => handleConfirm(e) }
                >
                  {I18n.t('js.common.button.confirm').toUpperCase()}
                </button>
              </React.Fragment>
          }
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  )
};

export default ShipmentDataModal;